import { z } from 'zod'

import ListItem from '@nxt-insurance/ui-kit/components/listComponents/ListItem'

import { Icon } from '@/components/Icon'
import type { PortableTextTypeComponentProps } from '@portabletext/react'

const checkmarkList = z.object({
  _key: z.string(),
  _type: z.literal('checkmarkList'),
  items: z.array(z.string()).optional(),
})

export const CheckMarkList = (props: { node: PortableTextTypeComponentProps<unknown> }) => {
  const value = checkmarkList.parse(props.node.value)
  const { items } = value
  if (!items) {
    return null
  }

  return (
    <ul className="flex flex-col gap-y-5">
      {items.map((item, index) => (
        <ListItem
          key={item}
          id={`${index}`}
          image={<Icon icon={{ name: 'circleCheckmark_24' }} size="small" />}
          title={item}
          icon="none"
          imageSize="small"
          paddingY="none"
        />
      ))}
    </ul>
  )
}
